/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutomationSourceCondition
 */
export interface AutomationSourceCondition {
    /**
     * 
     * @type {string}
     * @memberof AutomationSourceCondition
     */
    field: AutomationSourceConditionFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof AutomationSourceCondition
     */
    operator: AutomationSourceConditionOperatorEnum;
    /**
     * Claim origin to compare against.
     * @type {string}
     * @memberof AutomationSourceCondition
     */
    value: AutomationSourceConditionValueEnum;
}


/**
 * @export
 */
export const AutomationSourceConditionFieldEnum = {
    Source: 'source'
} as const;
export type AutomationSourceConditionFieldEnum = typeof AutomationSourceConditionFieldEnum[keyof typeof AutomationSourceConditionFieldEnum];

/**
 * @export
 */
export const AutomationSourceConditionOperatorEnum = {
    Eq: 'eq',
    Neq: 'neq'
} as const;
export type AutomationSourceConditionOperatorEnum = typeof AutomationSourceConditionOperatorEnum[keyof typeof AutomationSourceConditionOperatorEnum];

/**
 * @export
 */
export const AutomationSourceConditionValueEnum = {
    Manual: 'manual',
    Claimpredict: 'claimpredict',
    Widget: 'widget'
} as const;
export type AutomationSourceConditionValueEnum = typeof AutomationSourceConditionValueEnum[keyof typeof AutomationSourceConditionValueEnum];


/**
 * Check if a given object implements the AutomationSourceCondition interface.
 */
export function instanceOfAutomationSourceCondition(value: object): value is AutomationSourceCondition {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('operator' in value) || value['operator'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function AutomationSourceConditionFromJSON(json: any): AutomationSourceCondition {
    return AutomationSourceConditionFromJSONTyped(json, false);
}

export function AutomationSourceConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationSourceCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'],
        'operator': json['operator'],
        'value': json['value'],
    };
}

export function AutomationSourceConditionToJSON(json: any): AutomationSourceCondition {
    return AutomationSourceConditionToJSONTyped(json, false);
}

export function AutomationSourceConditionToJSONTyped(value?: AutomationSourceCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'operator': value['operator'],
        'value': value['value'],
    };
}

